import axios from "axios";

export async function getLogsByArea({ commit }, payload) {
  try {
    const response = await axios.get(
      `logbook/get-log-books-by/area/${payload.areaId}/${payload.page}`
    );
    return response.data;
  } catch (e) {
    return 0;
  }
}

export async function getLogsByClient({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `logbook/get-log-books-by-clieht`,
      payload
    );
    return data;
  } catch (e) {
    return 0;
  }
}

export async function getLogsByProspect({ commit }, prospectId) {
  try {
    const response = await axios.get(
      `logbook/get-log-books-by/prospect/${prospectId}`
    );
    return response.data;
  } catch (e) {
    return 0;
  }
}

export async function createLogBook({ commit }, data) {
  try {
    const response = await axios.post(`logbook/create-loogbook-client`, data);
    return response.data;
  } catch (e) {
    return 0;
  }
}

export async function updateLogBook({ commit }, data) {
  try {
    const response = await axios.post(`logbook/update-loogbook`, data);
    return response.data;
  } catch (e) {
    return 0;
  }
}

export async function geById({ commit }, payload) {
  try {
    const { data } = await axios.get(`logbook/${payload}`);
    return data;
  } catch (e) {
    return 0;
  }
}
